"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCountryList = exports.getPhoneMaxDigits = exports.formatPhone = exports.extractCountryCodeFromPhone = exports.DEFAULT_COUNTRY = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const examples_mobile_json_1 = __importDefault(require("libphonenumber-js/examples.mobile.json"));
__exportStar(require("./types"), exports);
__exportStar(require("libphonenumber-js"), exports);
exports.DEFAULT_COUNTRY = 'FR';
const extractCountryCodeFromPhone = (phone, options) => {
    const defaultCountryCode = options?.defaultCountry ?? exports.DEFAULT_COUNTRY;
    return (0, libphonenumber_js_1.parsePhoneNumberFromString)(phone)?.country ?? defaultCountryCode;
};
exports.extractCountryCodeFromPhone = extractCountryCodeFromPhone;
const formatPhone = (phone) => {
    if (!phone)
        return '';
    const parsed = (0, libphonenumber_js_1.parsePhoneNumberFromString)(phone);
    if (parsed && parsed.isValid()) {
        return `(+${parsed.countryCallingCode}) ${parsed.formatNational()}`;
    }
    return ((0, libphonenumber_js_1.parsePhoneNumberFromString)(phone, exports.DEFAULT_COUNTRY)?.formatNational() ?? phone);
};
exports.formatPhone = formatPhone;
const getPhoneMaxDigits = (countryCode) => {
    const NB_DEFAULT_DIGITS = 15;
    const example = (0, libphonenumber_js_1.getExampleNumber)(countryCode, examples_mobile_json_1.default);
    return example
        ? example.formatNational().replace(/\D/g, '').length
        : NB_DEFAULT_DIGITS;
};
exports.getPhoneMaxDigits = getPhoneMaxDigits;
const buildCountryList = (options) => {
    const defaultLocale = 'fr';
    const displayNames = typeof Intl !== 'undefined' && typeof Intl.DisplayNames !== 'undefined'
        ? new Intl.DisplayNames(defaultLocale, { type: 'region' })
        : null;
    const list = (0, libphonenumber_js_1.getCountries)()
        .flatMap((code) => {
        try {
            return [
                {
                    code,
                    name: displayNames?.of(code) ?? code,
                    flag: code
                        .toUpperCase()
                        .split('')
                        .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
                        .join(''),
                    callingCode: '+' + (0, libphonenumber_js_1.getCountryCallingCode)(code),
                },
            ];
        }
        catch {
            return [];
        }
    })
        .sort((a, b) => a.name.localeCompare(b.name, defaultLocale));
    if (!options?.defaultCountry) {
        return list;
    }
    const defaultCountryCodeIndex = list.findIndex((c) => c.code === options?.defaultCountry);
    if (defaultCountryCodeIndex > 0) {
        const defaultCountryCode = list.splice(defaultCountryCodeIndex, 1)[0];
        if (defaultCountryCode) {
            list.unshift(defaultCountryCode);
        }
    }
    return list;
};
exports.buildCountryList = buildCountryList;
